import type { DocumentItem } from 'src/components/pages/info/document/index/types'

type Translate = (_text: string) => string

export default function getKzDocuments(staticPath: string, translate: Translate): DocumentItem[] {
  const base = `${staticPath}_v1/ydoc/documents/info/kz`

  return [
    {
      id: 'kz-registration-ru',
      title: translate('Справка об учетной регистрации филиала юридического лица'),
      alt: translate('Справка об учетной регистрации филиала юридического лица'),
      previewSrc: `${base}/Казахстан_Справка_об_учетной_регистрации_филиала_юридического_лица.png`,
      src: `${base}/Казахстан_Справка_об_учетной_регистрации_филиала_юридического_лица.png`,
    },
    {
      id: 'kz-registration-kk',
      title: translate('Справка об учетной регистрации филиала юридического лица'),
      alt: translate('Справка об учетной регистрации филиала юридического лица'),
      previewSrc: `${base}/Казахстан_Справка_об_учетной_регистрации_филиала_юридического_лица_kk.png`,
      src: `${base}/Казахстан_Справка_об_учетной_регистрации_филиала_юридического_лица_kk.png`,
    },
  ]
}
